import { DomainUpsert } from "@/components/domain";
import { SelectSearch } from "@/components/select-search";
import { DatePicker } from "@/components/ui/date-picker";
import { Input } from "@/components/ui/input";
import {
  CreateFulfillment,
  FulfillmentsStateAsArray,
  FulfillmentState,
} from "@/models";
import { FormOptions } from "@deadcow-enterprises/react-forms";
import { useTranslation } from "react-i18next";

export function EditFulfillment({
  value,
  onUpsert,
}: {
  value: CreateFulfillment;
  onUpsert: (data: CreateFulfillment) => Promise<void>;
}) {
  const { t } = useTranslation();
  const formConfig: FormOptions<CreateFulfillment> = {
    agencyCharge: {
      value: value.agencyCharge,
    },
    expenses: {
      value: value.expenses,
    },
    serviceProviderId: {
      value: value.serviceProviderId,
    },
    value: {
      value: value.value,
    },

    state: {
      value: value.state ?? FulfillmentState.NotPayed,
    },
    dueDate: {
      value: value.dueDate,
    },
    invoiceNumber: {
      value: value.invoiceNumber,
    },
  };
  return (
    <DomainUpsert
      title={t("reservations.fulfillments.edit.title")}
      buttonTranslation={t("reservations.fulfillments.edit.button")}
      formConfig={formConfig}
      onUpsert={onUpsert}
      fields={[
        {
          key: "state",
          label: "reservations.fulfillments.fields.state",
          input: (form, id) => (
            <SelectSearch
              id={id}
              value={form.value.state ?? undefined}
              onChange={(v) => {
                form.setValue("state", v);
              }}
              options={
                FulfillmentsStateAsArray.map((o) => ({
                  value: o,
                  label: t(`reservations.fulfillments.state.${o}`),
                })) ?? []
              }
            />
          ),
        },
        {
          key: "dueDate",
          label: "reservations.fulfillments.fields.dueDate",
          input: (form, id) => (
            <DatePicker
              id={id}
              className="w-full"
              date={form.value.dueDate ?? undefined}
              setDate={(d) => {
                form.setValue("dueDate", d);
              }}
            />
          ),
        },
        {
          key: "invoiceNumber",
          label: "reservations.fulfillments.fields.invoiceNumber",
          input: (form, id) => (
            <Input
              id={id}
              value={form.value.invoiceNumber ?? ""}
              onChange={(e) => {
                form.setValue("invoiceNumber", e.target.value);
              }}
            />
          ),
        },
      ]}
    />
  );
}
